import { prefixerM } from '.'

export const ROUTE_BODEGA = prefixerM('bodega')
export const ROUTE_CATEGORIA_BIEN = prefixerM('categoria-bien')
export const ROUTE_GESTION_ITEMS = prefixerM('gestion-item')
export const ROUTE_INVENTARIOS = prefixerM('inventarios')
export const ROUTE_LINEAS_BIEN = prefixerM('lineas-bien')
export const ROUTE_MARCAS = prefixerM('marcas')
export const ROUTE_CREAR_CATEGORIA_BIEN = prefixerM('crear-categoria')
export const ROUTE_CREAR_LINEA_BIEN = prefixerM('crear-linea')
export const ROUTE_CREAR_MARCA = prefixerM('crear-marca')
export const ROUTE_CREAR_POLITICA = prefixerM('crear-politica')
